
<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title">{{ $t('externalUser.Candidate_applicant') }} {{ $t('globalTrans.search') }}</h4>
      </template>
      <template v-slot:body>
        <b-row>
            <b-col lg="6" md="6" sm="12">
                <ValidationProvider name="Year" vid="year">
                    <b-form-group
                        class="row"
                        label-cols-sm="4"
                        label-for="year"
                    >
                    <template v-slot:label>
                        {{ $t('event_manage.year')}}
                    </template>
                    <b-form-select
                        plain
                        v-model="search.year"
                        :options="yearList"
                        id="year"
                    >
                        <template v-slot:first>
                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col lg="6" md="6" sm="12">
                <ValidationProvider name="Circular Title" vid="circular_id">
                    <b-form-group
                        class="row"
                        label-cols-sm="4"
                        label-for="circular_id"
                    >
                    <template v-slot:label>
                        {{ $t('job_fair_management.circular_title')}}
                    </template>
                    <b-form-select
                        plain
                        v-model="search.circular_id"
                        :options="circularList"
                        id="circular_id"
                    >
                        <template v-slot:first>
                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col lg="6" md="6" sm="12">
                <ValidationProvider name="Disability Type" vid="disability_type_id">
                    <b-form-group
                        class="row"
                        label-cols-sm="4"
                        label-for="disability_type_id"
                    >
                    <template v-slot:label>
                        {{ $t('info_manage.disability_type')}}
                    </template>
                    <b-form-select
                        plain
                        v-model="search.disability_type_id"
                        :options="disabilityTypeList"
                        id="disability_type_id"
                    >
                        <template v-slot:first>
                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col lg="6" md="6" sm="12">
              <ValidationProvider name="Circular Title" vid="education_level_id">
                  <b-form-group
                      class="row"
                      label-cols-sm="4"
                      label-for="education_level_id"
                  >
                  <template v-slot:label>
                      {{ $t('awareness_config.education_level')}}
                  </template>
                  <b-form-select
                      plain
                      v-model="search.education_level_id"
                      :options="educationLevelList"
                      id="education_level_id"
                  >
                      <template v-slot:first>
                      <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                      </template>
                  </b-form-select>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col lg="6" md="6" sm="12">
                <div class="col-sm-4"></div>
                    <div class="col text-left">
                        <b-button type="submit" variant="primary" class="mr-2" @click="searchData">{{ $t('globalTrans.search') }}</b-button>
                    </div>
            </b-col>
        </b-row>
      </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('external_sidebar.candidate_applicant_list') }}</h4>
          </template>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <b-table thead-class="bg-primary" bordered hover :items="data" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>
                    <template v-slot:cell(application_id)="data">
                      {{ $n(data.item.application_id, { useGrouping: false   }) }}
                    </template>
                    <template v-slot:cell(mobile)="data">
                      {{ ($i18n.locale === 'bn') ? '০' : '0' }}{{ $n(data.item.mobile, { useGrouping: false }) }}
                    </template>
                    <template v-slot:cell(apply_date)="data">
                      {{ data.item.apply_date|dateFormat }}
                    </template>
                    <!-- <template v-slot:cell(education_level_id)>
                      {{ getEducationLevel(data.item.education_level_id) }}
                    </template> -->
                    <template v-slot:cell(disability_types)="data">
                      {{ getDisabilityTypeNameList(data.item.disability_types) }}
                    </template>
                     <template v-slot:cell(status)="data">
                       <span class="badge badge-warning" v-if="data.item.status == 1">{{ $t('globalTrans.pending') }}</span>
                       <span class="badge badge-primary" v-if="data.item.status == 2">{{ $t('job_fair_management.sorted') }}</span>
                       <span class="badge badge-success" v-if="data.item.status == 3">{{ $t('externalUser.confirm_applicant') }}</span>
                    </template>
                   <template v-slot:cell(action)="data">
                     <!-- <b-button  title="View Details" v-b-modal.modal-detail1 variant=" iq-bg-success border-info" size="sm" @click="details(data.item)"><i class="ri-eye-line m-0 "></i></b-button> -->
                     <router-link title="View CV" :to="`/employer-panel/applicant-cv-view?patient_id=${data.item.patient_id}`" class="btn btn-sm btn-info"><i class="ri-eye-line m-0 "></i></router-link>
                    </template>
                  </b-table>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-modal id="modal-detail" size="lg" :title="$t('info_manage.patient_details')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <template #modal-title class="flex-grow-1">
        {{ $t('info_manage.patient_details') }}
        <b-button variant="primary" @click="pdfExport" class="mr-2 float-right">
          {{  $t('globalTrans.export_pdf') }}
        </b-button>
      </template>
      <DetailModal :id="editItemId" :item="item" ref="details"/>
    </b-modal>
  </b-container>
</template>
<script>

import RestApi, { awarenessEventServiceBaseUrl } from '@/config/api_config'
import { candidateApplicantList, candidateApplicantToggleStatus } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import DetailModal from '@/modules/awareness-event-service/info-management-system/pages/common/DetailModal'
import flatpickr from 'flatpickr'
// import custom from '@/store/custom'
import { helpers } from '@/mixins/helper-functions'

export default {
  mixins: [ModalBaseMasterList],
   components: {
    DetailModal
  },
  data () {
    return {
      search: {
        year: 0,
        circular_id: 0,
        education_level_id: 0,
        disability_type_id: 0
      },
      rows: [],
      editItemId: 0,
      item: '',
      data: [],
      yearList: [],
      isRetailer: false,
      ItemShow: false,
      CityCorpItemShow: false,
      PauroshobaItemShow: false,
      UnionItemShow: false,
      districtList: [],
      upazilaList: [],
      unionList: [],
      cityCorporationList: [],
      pauroshobaList: [],
      wardList: []
    }
  },
  computed: {
     i18 () {
      return (this.$i18n.locale === 'bn') ? 1 : 0
    },
    monthList: function () {
      return this.$store.state.ProductionService.commonObj.monthList
    },
    circularList: function () {
        return this.$store.state.ExternalUser.employerCommonObj.circularList
    },
    fiscalYearList: function () {
      return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
    },
    registrationTypeList: function () {
        return this.$store.state.ProductionService.commonObj.registrationTypeList
    },
    currentLocale () {
      return this.$i18n.locale
    },
    disabilityTypeList () {
      return this.$store.state.ExternalUser.employerCommonObj.disabilityTypeList
    },
    educationLevelList: function () {
        return this.$store.state.ExternalUser.employerCommonObj.educationLevelList
    },
    patientList () {
      return this.$store.state.AwarenessEventService.commonObj.patientList
    },
    divisionList: function () {
      return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
    },
    columns () {
      const labels = [
          { label: this.$t('globalTrans.sl_no'), class: 'text-center' },
          { label: this.$t('globalTrans.name'), class: 'text-center' },
          { label: this.$t('globalTrans.mobile_no'), class: 'text-center' },
          { label: this.$t('info_manage.disability_type'), class: 'text-left' },
          { label: this.$t('job_fair_management.highest_education'), class: 'text-center' },
          { label: this.$t('job_fair_management.apply_date'), class: 'text-center' },
          { label: this.$t('globalTrans.address'), class: 'text-center' },
          { label: this.$t('globalTrans.status'), class: 'text-center' },
          { label: this.$t('globalTrans.action'), class: 'text-center' }
        ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
          { key: 'name_bn' },
          { key: 'mobile' },
          { key: 'disability_types' },
          { key: 'education_bn' },
          { key: 'apply_date' },
          { key: 'pr_address_bn' },
          { key: 'status' },
          { key: 'action' }
        ]
      } else {
        keys = [
         { key: 'index' },
          { key: 'name' },
          { key: 'mobile' },
          { key: 'disability_types' },
          { key: 'education' },
          { key: 'apply_date' },
          { key: 'pr_address_en' },
          { key: 'status' },
          { key: 'action' }
        ]
      }

      return labels.map((item, index) => {
          return Object.assign(item, keys[index])
        })
    }
  },
  watch: {
  },
  created () {
    this.loadData()
    this.getYearOptions()
  },
  mounted () {
    flatpickr('.date-picker', {})
  },
  methods: {
    getGenderName (Id) {
        const tmpData = this.$store.state.commonObj.genderList.find(item => item.value === parseInt(Id))
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData?.text_en
        }
    },
    details (item) {
      this.editItemId = item.id
      this.item = item
    },
    toggleStatus (item) {
        this.changeStatus(awarenessEventServiceBaseUrl, candidateApplicantToggleStatus, item)
    },
    searchData () {
      this.loadData()
    },
    async loadData () {
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      await RestApi.getData(awarenessEventServiceBaseUrl, candidateApplicantList, params).then(response => {
          if (response.success) {
            this.data = this.getCustomDataList(response.data.data)
          }
          this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    getCustomDataList (data) {
      const listData = data.map(item => {
        const educationList = this.educationLevelList.find(type => type.value === item.education_level_id)
          const educationData = {
            education: educationList !== undefined ? educationList?.text_en : '',
            education_bn: educationList !== undefined ? educationList.text_bn : ''
          }

          return Object.assign({}, item, educationData)
      })
      return listData
    },
    getDisabilityTypeNameList (disabilityTypes) {
        // disabilityTypes = disabilityTypes.replace(/[^,a-zA-Z0-9 ]/g, '').split(', ')
        // disabilityTypes = disabilityTypes.replace(/[[\]']+/g, '').split(', ')
        disabilityTypes = JSON.parse(disabilityTypes)
        const arr = []
        if (disabilityTypes.constructor === Array) {
            disabilityTypes.forEach(item => {
                const disabilityType = this.disabilityTypeList.find(obj => obj.value === parseInt(item))
                const disabilityTypeName = this.currentLocale === 'en' ? ' ' + disabilityType?.text_en : ' ' + disabilityType.text_bn
                arr.push(disabilityTypeName)
            })
        } else {
            const disabilityType = this.disabilityTypeList.find(obj => obj.value === disabilityTypes)
            const disabilityTypeName = this.currentLocale === 'en' ? ' ' + disabilityType?.text_en : ' ' + disabilityType.text_bn
            arr.push(disabilityTypeName)
        }
        return arr.toString()
        // return disabilityTypes.replace(/[^,a-zA-Z0-9 ]/g, '')
    },
    getYearOptions (startYear) {
      this.yearList = helpers.getYearList()
      return this.yearList
    },
    getEducationLevel (disabilityTypes) {
      const disabilityType = this.educationLevelList.find(obj => obj.value === parseInt(disabilityTypes))
      const disabilityTypeName = this.$i18n.locale === 'en' ? ' ' + disabilityType?.text_en : ' ' + disabilityType.text_bn
    return disabilityTypeName
    },
    pdfExport () {
      this.$refs.details.pdfExport()
    }
  }
}
</script>
<style>
.action {
  max-width: 12%
}
.modal-title {
  flex-grow: 1 !important;
}
</style>
